
import { defineComponent, PropType } from 'vue'

import { Maybe, Run } from '~/types/types'
import { fromNow } from '~/utils/date'

export default defineComponent({
  name: 'RepoConfigDetails',
  props: {
    errorCode: {
      type: Number,
      required: true
    },
    lastRun: {
      type: Object as PropType<Maybe<Run>>,
      required: true
    },
    owner: {
      type: String,
      required: true
    },
    vcsProviderIcon: {
      type: String,
      required: true
    },
    repoName: {
      type: String,
      required: true
    },
    repoVcsUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    configStatus() {
      if (this.errorCode === 0) {
        return {
          color: 'text-juniper-500',
          text: 'Valid configuration',
          icon: 'check-circle-2',
          buttonLabel: 'Edit configuration',
          buttonIcon: 'file-terminal'
        }
      }

      if (this.errorCode === 3001) {
        return {
          color: 'text-cherry-500',
          text: 'No configuration',
          icon: 'alert-circle',
          buttonLabel: 'Add configuration',
          buttonIcon: 'file-plus-2'
        }
      }

      if (this.errorCode === 3002) {
        return {
          color: 'text-honey-500',
          text: 'Invalid configuration',
          icon: 'alert-circle',
          buttonLabel: 'Edit configuration',
          buttonIcon: 'file-terminal'
        }
      }

      return null
    },
    lastRunFinishedAt() {
      const finishedAt = this.lastRun?.finishedAt

      if (!finishedAt) {
        return ''
      }

      return fromNow(finishedAt)
    }
  }
})
